import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    invisible: {
        display: "none"
    },
    dealerSearchContainer: {
        width: "100%",
        height:"100px"
    },
    dealerTableSection: {
        padding: "0px",
    },
    textBox: {
        minWidth: 50,
        maxWidth: 400,
        width: '50%',
        height: 30,
      },
      box: {
        maxHeight: '30px',
        minHeight: '30px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
      },
      header: {
        backgroundColor: '#ffffff',
        height: '60px',
        '& th': {
          height: '60px !important'
        }
      },
      label: {
          marginBottom: "10px",
          width: "20%",
          margin: "0"
      },
      alertLabel: {
        marginBottom: "15px",
        width: "100%",
      },
      divider: {
        marginBottom:"0px",
        marginTop:"0px",


      },
      button: {
        width: "20%"
      },
      delete: {
        padding: theme.spacing(1),
        margin: theme.spacing(0.7),
        stroke: theme.palette.grey[600],
        '&:hover': {
          stroke: theme.palette.grey[800],
        },
      },
      autocomplete: {
        height: 50,
        minWidth: 50,
        maxWidth: 400,
        width: '100%',
      },
      dropdown: {
        minWidth: 50,
        maxWidth: 400,
        width: '100%',
        textOverflow: 'ellipsis',
        height: 30,
      },
}));

export default useStyles;
